export default __webpack_public_path__ + "static/media/copy.b29768ea.svg";